<!--
 * @Author: zxf
 * @Date: 2022-08-03 17:39:28
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:04:54
 * @Description: 维保结论
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="维保结论"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :rules="fdRules"
      :inline="true"
      label-position="right"
      label-width="110px"
      label-suffix="："
    >
      <el-row
        class="c-form__row"
      >
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="维保情况简述"
            prop="qkjs"
          >
            <textarea-read
              v-if="type==='view'"
              v-model="fd.qkjs"
              class="c-form__read u-line-20"
            />
            <el-input
              v-else
              v-model="fd.qkjs"
              class="c-form__input"
              type="textarea"
              maxlength="5000"
              :autosize="{ minRows: 5, maxRows: 7}"
              placeholder="请输入维保情况简述"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="巡查情况"
            prop="xcqk"
          >
            <textarea-read
              v-if="type==='view'"
              v-model="fd.xcqk"
              class="c-form__read u-line-20"
            />
            <el-input
              v-else
              v-model="fd.xcqk"
              class="c-form__input"
              type="textarea"
              maxlength="5000"
              :autosize="{ minRows: 5, maxRows: 7}"
              placeholder="请输入巡查情况"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="保养情况"
            prop="byqk"
          >
            <textarea-read
              v-if="type==='view'"
              v-model="fd.byqk"
              class="c-form__read u-line-20"
            />
            <el-input
              v-else
              v-model="fd.byqk"
              class="c-form__input"
              type="textarea"
              maxlength="5000"
              :autosize="{ minRows: 5, maxRows: 7}"
              placeholder="请输入保养情况"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="巡查日期"
            prop="xcrq"
          >
            <span
              v-if="type==='view'"
              class="c-form__read"
            >{{ fd.xcrq | date('yyyy-MM-dd') }}</span>
            <el-date-picker
              v-else
              v-model="fd.xcrq"
              class="c-form__date"
              type="date"
              value-format="timestamp"
              placeholder="巡查日期"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="测试日期"
            prop="csrq"
          >
            <span
              v-if="type==='view'"
              class="c-form__read"
            >{{ fd.xcrq | date('yyyy-MM-dd') }}</span>
            <el-date-picker
              v-else
              v-model="fd.csrq"
              class="c-form__date"
              type="date"
              value-format="timestamp"
              placeholder="巡查日期"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"

        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>
<script>
import { wbjhService } from '../wbjh.service';
export default {
  name: 'WbjlDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    },
    type: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false, // 页面loading计划年份
      dialogShow: true, // 模态框dialog显示

      /* 表单参数 Start */
      fd: {
        qkjs: null,
        xcqk: null,
        byqk: null,
        xcrq: null,
        csrq: null
      },
      fdRules: {
        qkjs: [this.$HMValidator.maxLength('维保情况', 5000)],
        xcqk: [this.$HMValidator.maxLength('巡查情况', 5000)],
        byqk: [this.$HMValidator.maxLength('保养情况', 5000)]
      }
    };
  },
  methods: {
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          wbjhService.saveWbjl(_this.dlParams.jhid, _this.fd)
            .then(rsp => {
              _this.$alert('保存成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              _this.$emit('closeDialog', '');
              _this.$emit('callback');
            })
            .catch(err => {
              console.error('保存检测结论错误！', err);
              _this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 获取检测结论信息
     * @return {*}
     */
    getInfo () {
      wbjhService.getWbjlInfo(this.dlParams.jhid)
        .then(rsp => {
          this.fd = rsp.data;
        })
        .catch(err => {
          console.error('获取检测结论信息信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.getInfo();
  }
};
</script>
